/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Import_File_Encoding_LabelInputs */

const en_subtitle_import_file_encoding_label = /** @type {(inputs: Subtitle_Import_File_Encoding_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File Encoding`)
};

const fr_subtitle_import_file_encoding_label = /** @type {(inputs: Subtitle_Import_File_Encoding_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encodage du fichier`)
};

const de_subtitle_import_file_encoding_label = /** @type {(inputs: Subtitle_Import_File_Encoding_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dateikodierung`)
};

const it_subtitle_import_file_encoding_label = /** @type {(inputs: Subtitle_Import_File_Encoding_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codifica dei file`)
};

const ru_subtitle_import_file_encoding_label = /** @type {(inputs: Subtitle_Import_File_Encoding_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Кодировка файла`)
};

const es_subtitle_import_file_encoding_label = /** @type {(inputs: Subtitle_Import_File_Encoding_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codificación de archivos`)
};

const zh_cn2_subtitle_import_file_encoding_label = /** @type {(inputs: Subtitle_Import_File_Encoding_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文件编码`)
};

const ja_subtitle_import_file_encoding_label = /** @type {(inputs: Subtitle_Import_File_Encoding_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ファイルのエンコーディング`)
};

const hi_subtitle_import_file_encoding_label = /** @type {(inputs: Subtitle_Import_File_Encoding_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ाइल एन्कोडिंग`)
};

const pt_pt2_subtitle_import_file_encoding_label = /** @type {(inputs: Subtitle_Import_File_Encoding_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codificação de arquivo`)
};

/**
* | output |
* | --- |
* | "File Encoding" |
*
* @param {Subtitle_Import_File_Encoding_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_import_file_encoding_label = /** @type {((inputs?: Subtitle_Import_File_Encoding_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Import_File_Encoding_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_import_file_encoding_label(inputs)
	if (locale === "de") return de_subtitle_import_file_encoding_label(inputs)
	if (locale === "it") return it_subtitle_import_file_encoding_label(inputs)
	if (locale === "ru") return ru_subtitle_import_file_encoding_label(inputs)
	if (locale === "es") return es_subtitle_import_file_encoding_label(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_import_file_encoding_label(inputs)
	if (locale === "ja") return ja_subtitle_import_file_encoding_label(inputs)
	if (locale === "hi") return hi_subtitle_import_file_encoding_label(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_import_file_encoding_label(inputs)
	return en_subtitle_import_file_encoding_label(inputs)
});